"use client"

import { motion } from "framer-motion"
import { Menu, Plus, LogIn, User } from "lucide-react"
import { useAuth } from "@/contexts/AuthContext"

interface MobileFloatingMenuProps {
  onOpenSidebar: () => void
  onNewChat: () => void
  // Signed in, the account button opens the sidebar, where the account
  // actions sit at the bottom.
  onOpenAccount: () => void
}

export function MobileFloatingMenu({
  onOpenSidebar,
  onNewChat,
  onOpenAccount,
}: MobileFloatingMenuProps) {
  const { accountsEnabled, isLoading, isAuthenticated, openAuthModal } = useAuth()

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className="fixed left-2 top-2 z-40 flex items-center gap-1.5 p-1.5 bg-[rgba(232,226,255,0.5)] rounded-2xl shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[10px] border border-[rgba(232,226,255,0.7)]"
      style={{
        WebkitBackdropFilter: 'blur(10px)',
      }}
    >
      {/* Menu Button */}
      <button
        onClick={onOpenSidebar}
        className="p-2 hover:bg-white/20 rounded-xl transition-all duration-200 group"
        aria-label="Open menu"
      >
        <Menu className="w-4 h-4 text-gray-700 group-hover:text-gray-900 transition-colors" />
      </button>

      {/* New Chat Button */}
      <button
        onClick={onNewChat}
        className="p-2 hover:bg-white/20 rounded-xl transition-all duration-200 group"
        aria-label="New chat"
      >
        <Plus className="w-4 h-4 text-gray-700 group-hover:text-primary-600 group-hover:rotate-90 transition-all duration-300" />
      </button>

      {accountsEnabled && !isLoading && (
        <button
          onClick={isAuthenticated ? onOpenAccount : () => openAuthModal("login")}
          className="p-2 hover:bg-white/20 rounded-xl transition-all duration-200 group"
          aria-label={isAuthenticated ? "Konto" : "Anmelden"}
        >
          {isAuthenticated ? (
            <User className="w-4 h-4 text-gray-700 group-hover:text-primary-600 transition-colors" />
          ) : (
            <LogIn className="w-4 h-4 text-gray-700 group-hover:text-primary-600 transition-colors" />
          )}
        </button>
      )}
    </motion.div>
  )
}
